import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type EnsRecord = ObjectId & {
  name?: string;
};

type EnsRecordAlreadyExistsInProjectErrorOptions = {
  ensRecord: EnsRecord;
  project: ObjectId;
};

export class EnsRecordAlreadyExistsInProjectError extends FleekError<EnsRecordAlreadyExistsInProjectErrorOptions> {
  public name = 'EnsRecordAlreadyExistsInProjectError';

  toString = () => {
    return `ENS record already exists under the project.`;
  };
}
